import classNames from 'classnames'

export const FORM_ELEMENT_BORDER_COLOR = "border-stone-400"
export const FORM_ELEMENT_STYLE = classNames("text-stone-700 font-medium whitespace-nowrap rounded-md border-[1px]", FORM_ELEMENT_BORDER_COLOR)
